import {ChangeDetectionStrategy, Component, computed, inject, input, signal} from '@angular/core';
import {Store} from '@ngrx/store';
import {CommonModule, Location} from '@angular/common';
import {MatToolbar} from '@angular/material/toolbar';
import {selectError, selectLoading, selectSelectedSummary} from '../../services/summary/summary.selectors';
import {MatCardModule} from '@angular/material/card';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatListModule} from '@angular/material/list';
import {MarkdownComponent, provideMarkdown} from 'ngx-markdown';
import {MatTabsModule} from '@angular/material/tabs';
import {
  ResearchPaperListComponent
} from '../../../research/components/research-paper-list/research-paper-list.component';
import {MatIconButton} from '@angular/material/button';
import {SummaryChatWindowComponent} from '../summary-chat-window/summary-chat-window.component';
import {MatIcon} from '@angular/material/icon';
import {CUSTOM_FILTER} from '../../../research/models/filter';
import {LoadingCardComponent} from '../../../../utils/components/loading-card/loading-card.component';
import {ErrorCardComponent} from '../../../../utils/components/error-card/error-card.component';


@Component({
  selector: 'app-summary-window',
  imports: [
    CommonModule,
    MatToolbar,
    MatProgressSpinnerModule,
    MatListModule,
    MatCardModule,
    MarkdownComponent,
    MatTabsModule,
    ResearchPaperListComponent,
    SummaryChatWindowComponent,
    MatIconButton,
    MatIcon,
    LoadingCardComponent,
    ErrorCardComponent
  ],
  templateUrl: './summary-window.component.html',
  styleUrl: './summary-window.component.scss',
  providers: [
    provideMarkdown(),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryWindowComponent {
  private readonly store: Store = inject(Store);
  private readonly location: Location = inject(Location);

  readonly summaryId = input<string>();
  protected selectedTabIndex = signal(0);

  readonly projectSummary = this.store.selectSignal(selectSelectedSummary);
  readonly projectId = computed(() => this.projectSummary()?.projectId);
  readonly papersSummary = computed(() => this.projectSummary()?.paperSummaries ?? []);
  readonly loading = this.store.selectSignal(selectLoading);
  readonly error = this.store.selectSignal(selectError);
  readonly found = computed(() => !!this.projectSummary());

  readonly papersFilter = [
    CUSTOM_FILTER.ALL_IDENTIFIED_ARTICLES,
    CUSTOM_FILTER.TITLE_ABSTRACT_SCREENING_PASSED,
    CUSTOM_FILTER.FULL_TEXT_SCREENING_PASSED,
    CUSTOM_FILTER.MANUAL_OVERWRITTEN
  ]

  getPapersIds(): number[] {
    return this.papersSummary().map(d => d.paperId);
  }


  goBack(): void {
    this.location.back();
  }

  indexChange(index: number) {
    this.selectedTabIndex.set(index);
  }
}
